module.exports = __webpack_public_path__ + "static/media/house5.1cb5c824.png";